

import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function About() {
  const team = [
    {
      id: 1,
      name: 'John Mitchell',
      position: 'Founder & CEO',
      image: 'https://public.readdy.ai/ai/img_res/f09f669bb0c7f7d702af02db6156fe50.jpg',
      bio: '25+ years in construction and landscaping industry'
    },
    {
      id: 2,
      name: 'Sarah Thompson',
      position: 'Head of Landscape Design',
      image: 'https://readdy.ai/api/search-image?query=Professional%20landscape%20architect%20woman%2C%20garden%20designer%2C%20outdoor%20design%20expert%2C%20professional%20woman%20in%20landscaping%20industry&width=300&height=400&seq=34&orientation=portrait',
      bio: 'Award-winning landscape architect with 15 years experience'
    },
    {
      id: 3,
      name: 'Mike Rodriguez',
      position: 'Construction Manager',
      image: 'https://readdy.ai/api/search-image?query=Professional%20construction%20manager%2C%20construction%20industry%20professional%2C%20project%20manager%2C%20experienced%20construction%20worker%20in%20business%20attire&width=300&height=400&seq=35&orientation=portrait',
      bio: 'Expert in residential and commercial construction projects'
    },
    {
      id: 4,
      name: 'Emily Chen',
      position: 'Project Coordinator',
      image: 'https://readdy.ai/api/search-image?query=Professional%20project%20coordinator%20woman%2C%20construction%20industry%20professional%2C%20business%20woman%2C%20project%20management%20expert&width=300&height=400&seq=36&orientation=portrait',
      bio: 'Ensures seamless project execution and client satisfaction'
    }
  ];

  const values = [
    {
      icon: 'ri-award-line',
      title: 'Quality Excellence',
      description: 'We never compromise on quality and use only the finest materials and craftsmanship'
    },
    {
      icon: 'ri-handshake-line',
      title: 'Client Trust',
      description: 'Building lasting relationships through transparency, reliability, and exceptional service'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability',
      description: 'Committed to environmentally responsible practices and sustainable solutions'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'Embracing new technologies and methods to deliver better results'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">About Chavez Castro</h1>
              <p className="text-xl text-gray-600 mb-6">
                For over 25 years, Chavez Castro has been transforming dreams into reality through 
                exceptional construction and landscaping services. We combine traditional craftsmanship 
                with modern innovation to deliver outstanding results.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Our commitment to quality, sustainability, and client satisfaction has made us 
                the trusted choice for homeowners and businesses throughout the region.
              </p>
              <Link to="/contact">
                <Button size="lg">Get In Touch</Button>
              </Link>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20construction%20and%20landscaping%20company%20team%2C%20construction%20workers%20and%20landscape%20designers%2C%20diverse%20team%2C%20company%20culture%2C%20teamwork%20in%20construction%20industry&width=600&height=500&seq=37&orientation=portrait"
                alt="Chavez Castro Team"
                className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Story</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From humble beginnings to industry leaders
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">1999</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Founded</h3>
              <p className="text-gray-600">
                Started as a small family business with a passion for quality construction
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">2010</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Expansion</h3>
              <p className="text-gray-600">
                Added landscaping services and expanded our team of skilled professionals
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">2024</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Today</h3>
              <p className="text-gray-600">
                Leading provider with 500+ completed projects and countless satisfied clients
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Values</h2>
            <p className="text-xl text-gray-600">The principles that guide everything we do</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Team</h2>
            <p className="text-xl text-gray-600">The experts behind our success</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member) => (
              <div key={member.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6 text-center">
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-red-700 font-medium mb-2">{member.position}</p>
                  <p className="text-gray-600 text-sm">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Certifications & Awards</h2>
            <p className="text-xl text-gray-600">Recognition of our commitment to excellence</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Licensed & Insured</h3>
              <p className="text-gray-600">Fully licensed contractors with comprehensive insurance coverage</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Industry Awards</h3>
              <p className="text-gray-600">Multiple awards for excellence in construction and landscape design</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Green Certified</h3>
              <p className="text-gray-600">Certified in sustainable building practices and eco-friendly solutions</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Ready to Work With Us?</h2>
          <p className="text-xl text-red-100 mb-8">
            Let's discuss your next construction or landscaping project
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-white text-red-700 hover:bg-gray-100">
                Start Your Project
              </Button>
            </Link>
            <Link to="/portfolio">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-red-700">
                View Our Work
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

